import React from 'react';
import Header from '../../layout/header/Header';
import Form from '../../layout/form/Form';
import FormCard from '../../components/formCard/formCard';
import { FormCardData } from '../../types/types';
import { useAppSelector, useAppDispatch } from '../../store/store';
import { updateFormCardsData } from '../../store/formPageReducer';
import './_formpage.scss';

export default function Formpage() {
  const dispatch = useAppDispatch();
  const { formCardsData } = useAppSelector((state) => state.formPage);

  const handleSubmit = (submitData: FormCardData) => {
    dispatch(updateFormCardsData(submitData));
  };

  const formsArray = formCardsData;
  console.log(formsArray);
  return (
    <React.Fragment>
      <Header />
      <main className="main">
        <div className="wrapper main__wrapper">
          <div className="main__content">
            <h2 className="main__title">Subscribe form</h2>
            <Form onSubmit={handleSubmit} />
            <div className="form-cards">
              {formsArray.map((card, i) => (
                <FormCard key={i} cardData={card} />
              ))}
            </div>
          </div>
        </div>
      </main>
    </React.Fragment>
  );
}
